import React from "react";
import RichText from "./RichText";

/**
 * Section: eyebrow + optional headline + children.
 * eyebrow/title accept either JSX defaults or CMS strings with our inline markdown.
 */
export default function Section({ eyebrow, title, children, className = "", tight = false, testId }) {
  return (
    <section
      className={`container-narrow ${tight ? "py-14 sm:py-16" : "py-20 sm:py-24"} ${className}`}
      data-testid={testId}
    >
      <div className="max-w-3xl">
        {eyebrow && <RichText as="div" className="eyebrow mb-5" value={eyebrow} />}
        {title && (
          <RichText as="h2" className="display text-[30px] sm:text-[40px] lg:text-[46px] mb-8" value={title} />
        )}
        <div className="prose-qr">{children}</div>
      </div>
    </section>
  );
}
